import React from 'react'
import styles from '../../styles/MenuDetail.module.css'
import { Link as ScrollLink, Element } from 'react-scroll';
import { Breadcrumbs } from '../../components/Breadcrumb'

const FacesHifu = () => {
  return (
    <>
        <section className={styles.fv_area}>
            <h2>HIFU</h2>
        </section>
        <Breadcrumbs />

        <section className={styles.jump_link_area}>
            <ul>
                <li>
                    <ScrollLink to="target" smooth={true}>おすすめの方</ScrollLink>
                </li>
                <li>
                    <ScrollLink to="flow" smooth={true}>施術の流れ</ScrollLink>
                </li>
                {/* <li>
                    <ScrollLink to="case" smooth={true}>症例写真</ScrollLink>
                </li> */}
                <li>
                    <ScrollLink to="price" smooth={true}>料金</ScrollLink>
                </li>
            </ul>
        </section>

        <Element className={styles.about_area} name='target'>
            <h2>HIFUとは</h2>
            <p>
                高密度焦点式超音波(HIFU:high intensity focused ultrasound)は、超音波の音響振動エネルギーを 焦点に集中させ、<br />
                60℃以上の高い熱を1mm以下の小さな点を発生させる仕組みでございます。<br />
                高い引き締め効果が期待できるレーザーのような治療機器でございます。
            </p>
            <div className={styles.img_wrapper}>
                <img src='/images/about-area-faces-hifu-img.png' alt='about-area-faces-hifu-img' className={styles.pc_img}/>
                <img src='/images/about-area-faces-hifu-sp-img.png' alt='about-area-faces-hifu-sp-img' className={styles.sp_img}/>
            </div>
            <div className={styles.target}>
                <h3>おすすめの方</h3>
                <ul>
                    <li>
                        <img src='/images/check-icon.png' className={styles.check_icon} alt='img' />糸リフト後のメンテナンスで顔を引き締めたい方
                    </li>
                    <li>
                        <img src='/images/check-icon.png' className={styles.check_icon} alt='img' />定期的なアンチエイジング治療がしたい方
                    </li>
                    <li>
                        <img src='/images/check-icon.png' className={styles.check_icon} alt='img' />引き締めと同時に美肌にしたい方
                    </li>
                    <li>
                        <img src='/images/check-icon.png' className={styles.check_icon} alt='img' />顔の左右差が気になる方
                    </li>
                    <li>
                        <img src='/images/check-icon.png' className={styles.check_icon} alt='img' />注射や吸引をせずに脂肪を少しずつ減らしたい方
                    </li>
                </ul>
            </div>
        </Element>
        <Element className={styles.flow_area} name='flow'>
            <h2>施術の流れ</h2>
            <div className={styles.cards}>
                <div className={styles.card}>
                    <div>
                        <img src='/images/flow-img.png' className={styles.card_img} alt='img' />
                    </div>
                    <div>
                        <div className={styles.title}>カウンセリングで理想のフェイスラインをお伺いいたします。</div>
                        <div className={styles.text}>
                            無料カウンセリングではまずフェイスラインの状態を確認し、患者様にあったを施術ご提案いたします。
                        </div>
                    </div>
                </div>

                <div className={styles.card}>
                    <div>
                        <img src='/images/flow-img2.png' className={styles.card_img} alt='img' />
                    </div>
                    <div>
                        <div className={styles.title}>ご希望のフェイスラインに添って施術を行います。</div>
                        <div className={styles.text}>
                            空きがあればカウンセリング当日の施術も可能です。施術時間は20-30分程度になります。
                        </div>
                    </div>
                </div>

                <div className={styles.card}>
                    <div>
                        <img src='/images/flow-img3.png' className={styles.card_img} alt='img' />
                    </div>
                    <div>
                        <div className={styles.title}>施術後はそのままお帰りいただけます。</div>
                        <div className={styles.text}>
                            施術によってはパウダールームにてお化粧しご帰宅可能です。特に通院の必要はございませんが、気になることなどございましたら、クリニックにお気軽にご連絡ください。
                        </div>
                    </div>
                </div>

            </div>
        </Element>
        {/* <Element className={styles.case_area} name='case'>
            <h2>HIFUの症例写真</h2>
            <div className={styles.items}>
                <div className={styles.item}>
                    <div>
                        <img src='/images/case-area-img.png' className={styles.case_img} alt='img' />
                    </div>
                </div>
                <div className={styles.item}>
                    <div>
                        <img src='/images/case-area-img2.png' className={styles.case_img} alt='img' />
                    </div>
                </div>
                <div className={styles.item}>
                    <div>
                        <img src='/images/case-area-img3.png' className={styles.case_img} alt='img' />
                    </div>
                </div>
            </div>
        </Element> */}

        <Element className={styles.price_area} name='price'>
            <h2>料金</h2>
            <div className={styles.price_lists}>
                <div className={styles.price_list}>
                    <div>HIFUスタンダード</div>
                    <div>¥52,800</div>
                </div>
                <div className={styles.price_list}>
                    <div>HIFUプレミアム</div>
                    <div>¥96,800</div>
                </div>
                <div className={styles.price_list}>
                    <div>HIFU(頬・こめかみ・おでこ)</div>
                    <div>¥33,000</div>
                </div>
                <div className={styles.price_list}>
                    <div>HIFUリニア顎下</div>
                    <div>¥96,800</div>
                </div>
                <ul className={styles.annotation}>
                    <li>スタンダード：4.5mmの筋膜層</li>
                    <li>プレミアム：4.5mmの筋膜層＋3.0mmの脂肪層</li>
                    <li>※料金は全て「税込」記載となります</li>
                </ul>
            </div>
            <div className={styles.supplement}>
                <div>
                    <h3>治療期間・回数</h3>
                    <p>
                        ・治療期間：1ヶ月<br />
                        ・通院：必要なし
                    </p>
                </div>
                <div>
                    <h3>リスク・副作用</h3>
                    <ul>
                        <li>・痛み</li>
                        <li>・痺れ</li>
                        <li>・火傷</li>
                    </ul>
                </div>
            </div>
        </Element>
    </>
  )
}

export default FacesHifu